import * as types from "./types";
import * as actionTypes from "./actionTypes";

const initialStateMetaDataExtractor: types.IPostMetaDataExtractorState = {
    pending: false,
    extMetaDataStatus: [],
    error: null,
};

export const PostMetaDataExtractorReducer = (state = initialStateMetaDataExtractor, action: types.PostMetaDataExtractorActions) => {
    switch (action.type) {
        case actionTypes.POST_METADATAEXTRACTOR_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_METADATAEXTRACTOR_SUCCESS:
            return {
                ...state,
                pending: false,
                extMetaDataStatus: [...state.extMetaDataStatus!, action.payload.extMetaDataStatus],
                error: null,
            };
        case actionTypes.POST_METADATAEXTRACTOR_FAILURE:
            return {
                ...state,
                pending: false,      
                extMetaDataStatus: [...state.extMetaDataStatus!, action.payload.extMetaDataStatus],          
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


//Put MetadaData extractor
const initialPutStateMetaDataExtractor: types.IPutExtractorMetadataState = {
    pending: false,
    extMetaDataStatus: null,
    error: null,
};

export const PutMetaDataExtractorReducer = (state = initialPutStateMetaDataExtractor, action: types.PutExtractorMetadataActions) => {
    switch (action.type) {
        case actionTypes.PUT_METADATAEXTRACTOR_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_METADATAEXTRACTOR_SUCCESS:
            return {
                ...state,
                pending: false,
                extMetaDataStatus: action.payload.extMetaDataStatus,
                error: null,
            };
        case actionTypes.PUT_METADATAEXTRACTOR_FAILURE:
            return {
                ...state,
                pending: false,
                extMetaDataStatus: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

//Get Extractor Table Metadata

const initEXTTableMetaDataState: types.EXTTableMetaDataState = {
    pending: false,
    tableMetadata: {},
    error: null,
};

export const EXTTableMetaDataReducer = (state = initEXTTableMetaDataState, action: types.EXTTableMetaDataActions) => {
    switch (action.type) {
        case actionTypes.FETCH_EXTTABLEMETADATA_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_EXTTABLEMETADATA_SUCCESS:
            return {
                ...state,
                pending: false,
                tableMetadata: state.tableMetadata
                ? {
                    ...state.tableMetadata,
                    [action.payload.table_name]: action.payload.tableMetadata,
                  }
                : { [action.payload.table_name]: action.payload.tableMetadata },
                error: null,
            };
        case actionTypes.FETCH_EXTTABLEMETADATA_FAILURE:
            return {
                ...state,
                pending: false,
                tableMetadata: state.tableMetadata ? { ...state.tableMetadata } : {},
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

//Get Foundry MetaData
const initFoundryMetaDataState: types.FoundryMetaDataState = {
    pending: false,
    foundryMetadata: {} as types.IGETFoundryMetaData[],
    error: null,
};

export const FoundryMetaDataReducer = (state = initFoundryMetaDataState, action: types.FoundryMetaDataActions) => {
    switch (action.type) {
        case actionTypes.FETCH_FOUNDRYTABLEMETADATA_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_FOUNDRYTABLEMETADATA_SUCCESS:
            return {
                ...state,
                pending: false,
                foundryMetadata: action.payload.foundryMetadata,
                error: null
            };
        case actionTypes.FETCH_FOUNDRYTABLEMETADATA_FAILURE:
            return {
                ...state,
                pending: false,
                foundryMetadata: {} as types.IGETFoundryMetaData[],
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

